import $ = require('jquery');
import l10n from 'diy/util/l10n';
import ModuleHelper = require('./ModuleHelper');
import Modul from '../../../Modul';
import {format} from 'diy/util/string';
/**
 * Drag helper for existing modules
 *
 * @depends Modul.js
 */

    class ExistingModuleHelper extends ModuleHelper {
        protected restrictedTooltipOptions = {
            anchorOffset: -10,
            alignment: 'left',
            alignmentOffset: 135 / 2
        };
        create(sourceElem: JQuery) {
            let moduleObj = this.getModule();

            let $helper = $('<div></div>').appendTo('body');

            if (diy.editor.uiPreference.isPointerModeTouch()) {
                $helper.addClass('diye-module-drag-helper');
                let $content = $('<div class="diye-module-drag-helper-content"></div>');
                $content.html(this.getLabel());
                $content.appendTo($helper);
            } else {

                $helper[0].className = moduleObj.modul[0].className;
                $helper.removeClass('open');

                let contentEl = moduleObj.getContentContainer().clone();
                 contentEl.appendTo($helper);

                $helper.addClass('drag-container');

                //need to set correct dimensions
                $helper.css({
                    'height': moduleObj.modul.height(),
                    'width': moduleObj.modul.width()
                });
                $helper.find('.width-warning-text-wrapper').remove();
                $helper.find('.diye-warning-veil').remove();

                //add custom border. See #DHDIYED-342
                $helper.addClass("module-drag-border");
            }

            return $helper;
        }

        getModule() {
            let moduleId = this.originalElement.closest('[data-moduleId]').attr('data-moduleId');
            return Modul.getInstance(moduleId);
        }

        getLabel() {
            let label = l10n('module.dragHelperLabel');
            return format(label, this.getModule().textLabel);
        }

        setError(error: string) {
            if (!diy.editor.uiPreference.isPointerModeTouch()) {
                return super.setError(error);
            }

            // Override the base method for touch devices, replacing the tooltip with an inline message

            let $content = $('.diye-module-drag-helper-content', this.element);
            $content.toggleClass('drag-helper-error', error !== null);
            $content.html(error !== null ? error : this.getLabel());
        }
    }

export = ExistingModuleHelper;



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/module/common/js/dd/ExistingModuleHelper.ts
 **/